import React, { Suspense } from 'react';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';

import Layout from 'components/Layout/Layout';
import Loader from 'components/Loader';

import Login from 'pages/auth/Login';
import DuoLogin from 'pages/auth/DuoLogin';
import ExternalLogin from 'pages/auth/ExternalLogin';

import {
  AUTOTASK_POD,
  AUTOTASK_POD_FULL_SIZE,
  AUTOTASK_POD_WIDGET,
  CONNECTWISE_POD,
  DUO_LOGIN,
  EXTERNAL_LOGIN,
  FRESH_SERVICE_FULL_SIZE,
  FRESH_SERVICE_POD,
  FRESH_SERVICE_POD_WIDGET,
  // FRESH_SERVICE_POD_FULL_SIZE,
  HALO_POD,
  IMPORT_INTEGRATION_POD,
  KASEYA_POD,
  MICROSOFT_365_POD,
  SUPER_OPS_POD,
  SERVICE_NOW_POD,
  SYNCRO_POD,
  ZENDESK_POD,
  WEB_EXTENSION_POD,
} from 'router/routes';

const AutotaskPod = React.lazy(() => import('pages/autotask'));
const ConnectwisePod = React.lazy(() => import('pages/connectwise'));
const HaloPod = React.lazy(() => import('pages/halo'));
const FreshServicePod = React.lazy(() => import('pages/freshService/FreshServicePod'));
const FullSizeAutotask = React.lazy(() => import('pages/fullSizeAutotask'));
const FullSizefreshService = React.lazy(() => import('pages/FullSizeFreshService'));
const KaseyaPod = React.lazy(() => import('pages/kaseya'));
const SyncroPod = React.lazy(() => import('pages/syncro'));
const SuperOpsPod = React.lazy(() => import('pages/superOps'));
const ServiceNowPod = React.lazy(() => import('pages/serviceNow'));
const ZendeskPod = React.lazy(() => import('pages/zendesk'));
const MicrosoftPod = React.lazy(() => import('pages/microsoft/MicrosoftPOD'));
const WebExtensionPod = React.lazy(() => import('pages/webExtension/WebExtensionPod'));
const ImportIntegrationPod = React.lazy(
  () => import('pages/importIntegration/ImportIntegrationPod'),
);

const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={'/login'} element={<Login />} />
        <Route path={DUO_LOGIN} element={<DuoLogin />} />
        <Route path={EXTERNAL_LOGIN} element={<ExternalLogin />} />

        <Route
          path="/pod"
          element={
            <Suspense fallback={<Loader />}>
              <Layout>
                <Outlet />
              </Layout>
            </Suspense>
          }
        >
          <Route path={CONNECTWISE_POD} element={<ConnectwisePod />} />
          <Route path={HALO_POD} element={<HaloPod />} />
          <Route path={AUTOTASK_POD_FULL_SIZE} element={<FullSizeAutotask />} />
          <Route path={FRESH_SERVICE_FULL_SIZE} element={<FullSizefreshService />} />
          <Route path={KASEYA_POD} element={<KaseyaPod />} />
          <Route path={SYNCRO_POD} element={<SyncroPod />} />
          <Route path={SUPER_OPS_POD} element={<SuperOpsPod />} />
          <Route path={ZENDESK_POD} element={<ZendeskPod />} />
          <Route path={AUTOTASK_POD} element={<AutotaskPod />} />
          <Route path={FRESH_SERVICE_POD} element={<FreshServicePod />} />
          <Route path={MICROSOFT_365_POD} element={<MicrosoftPod />} />
          <Route path={SERVICE_NOW_POD} element={<ServiceNowPod />} />
          <Route path={IMPORT_INTEGRATION_POD} element={<ImportIntegrationPod />} />
        </Route>
        <Route
          path={WEB_EXTENSION_POD}
          element={
            <Suspense fallback={<Loader />}>
              <Layout>
                <WebExtensionPod />
              </Layout>
            </Suspense>
          }
        />
        <Route
          path={AUTOTASK_POD_WIDGET}
          element={
            <Suspense fallback={<Loader />}>
              <Layout>
                <AutotaskPod />
              </Layout>
            </Suspense>
          }
        />
        <Route
          path={FRESH_SERVICE_POD_WIDGET}
          element={
            <Suspense fallback={<Loader />}>
              <Layout>
                <FreshServicePod />
              </Layout>
            </Suspense>
          }
        />
        <Route path={'/*'} element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
